// components/auth/HiddenFromCustomer.tsx
/**
 * The superadmin's marker for a section the account's members don't see
 * (plan 2026-10-23-superadmin-sees-sections-hidden-from-the-customer §2):
 * an eye-off mark next to a nav item and one banner on top of the page.
 * Only `useSectionAccess` decides when either renders.
 */

import { Alert, Text, Tooltip } from "@mantine/core";
import { IconEyeOff } from "@tabler/icons-react";

const MARK_TOOLTIP =
  "Hidden from this account: members don't see this. Change it in Superadmin → Clients → Modules.";

export function HiddenFromCustomerMark({ size = 14 }: { size?: number }) {
  return (
    <Tooltip label={MARK_TOOLTIP} multiline w={260} withArrow>
      <span
        role="img"
        aria-label="Hidden from customer"
        data-testid="hidden-from-customer-mark"
        style={{ display: "inline-flex", color: "var(--mantine-color-yellow-7)", flexShrink: 0 }}
      >
        <IconEyeOff size={size} stroke={1.5} />
      </span>
    </Tooltip>
  );
}

export function HiddenFromCustomerBanner() {
  return (
    <Alert
      variant="light"
      color="yellow"
      radius={0}
      py={6}
      icon={<IconEyeOff size={16} stroke={1.5} />}
      data-testid="hidden-from-customer-banner"
    >
      <Text size="sm">
        <Text span fw={500}>Hidden from customer:</Text> members of this account don't see this
        section. What you create here can reach this account's members.
      </Text>
    </Alert>
  );
}
